import { Tag } from './tag';
import { TagService } from './tag.service';

export function resolveTagList(tagService: TagService): Promise<Tag[]> {
  return new Promise((resolve) => {
    tagService.getList().subscribe(resolve);
  });
}
